import React from "react";
import PonenciaListD from "./PonenciaListDesktop";
import PlaysList from "./PlaysListMobile";
import { useMediaQuery } from 'react-responsive'


export default function PlaysListResponsive(){
    const isMobileDevice = useMediaQuery({
        query: "(max-width: 48em)",
      });

  return(
      <div>
        {!isMobileDevice && <PonenciaListD/>}
        {isMobileDevice && <PonenciaListD/>}  
      </div>
    )
}

